import React from 'react';
import { useTranslation } from 'react-i18next';

import EnergyBenefitsWidget from '../SolarisCalculator/EnergyBenefitsWidget';

import styles from './SolarisCalculator.module.scss';

const SolarisCalculator = ({ ...props }) => {
  const { t } = useTranslation(['solaris']);

  return (
    <section className={styles.container}>
      <h1>{t(`solaris:title`)}</h1>
      <article>
        <h2>{t(`solaris:calculator-header`)}</h2>
        <EnergyBenefitsWidget {...props} />
      </article>
    </section>
  );
};

export default SolarisCalculator;
